<div class="flex flex-col gap-4 p-4 border border-gray-200 rounded-lg bg-white h-[208px]">
  <!-- Header: Name + Badge + Menu -->
  <div class="flex flex-row items-center gap-2">
    <fa-icon
      [class]="isValid ? 'text-green' : 'text-yellow'"
      [icon]="isValid ? faCircleCheck : faCircleExclamation"
      [tooltip]="validationTooltip"
      class="text-svg-16 shrink-0"
      tooltipDirection="top"></fa-icon>
    <span class="text-sm font-medium text-gray-900 truncate flex-1">{{ ruleset.name }}</span>
    @if (isLinkedIn) {
      <bic-badge [bgClass]="'bg-blue-100'" [textClass]="'text-blue-900'">Geteilt</bic-badge>
    }
    @if (catalogBadgeLabel) {
      <span [tooltip]="catalogBadgeTooltip" class="shrink-0" tooltipDirection="top">
        <bic-badge [bgClass]="catalogSubmission?.status === 'REJECTED' ? 'bg-red-100' : catalogSubmission?.status === 'INSTALLED' ? 'bg-green-100' : 'bg-yellow-100'"
                   [textClass]="catalogSubmission?.status === 'REJECTED' ? 'text-red' : catalogSubmission?.status === 'INSTALLED' ? 'text-green-900' : 'text-yellow-900'">{{ catalogBadgeLabel }}</bic-badge>
      </span>
    }
    <bic-badge [bgClass]="RULESET_TYPE_CONFIG[ruleset.type].bgClass" [textClass]="RULESET_TYPE_CONFIG[ruleset.type].textClass">{{ RULESET_TYPE_CONFIG[ruleset.type].label }}</bic-badge>
    <!-- Bei einem bereitgestellten myCheck ersetzt das Schloss-Icon das Punktemenü: Duplizieren
         ist die einzige erlaubte Aktion und über den Button unten ohnehin erreichbar. -->
    @if (isProvided) {
      <fa-icon [icon]="faLock"
               [tooltip]="lockTooltip"
               class="text-svg-14 text-gray-400 shrink-0"
               tooltipDirection="top"></fa-icon>
    } @else {
      <button (click)="$event.stopPropagation()"
              [bicDropdownTrigger]="cardMenu"
              class="flex items-center justify-center w-4 h-4 text-gray-500 hover:text-gray-700">
        <fa-icon [icon]="faEllipsisVertical" class="text-xs"></fa-icon>
      </button>
      <bic-dropdown #cardMenu [dropdownPlacement]="'bottom-end'">
        @if (canDuplicate) {
          <bic-dropdown-element (click)="onDuplicate()">
            <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
              <fa-icon [icon]="faCopy" class="text-sm text-gray-700 w-4"></fa-icon>
              <span>Duplizieren</span>
            </div>
          </bic-dropdown-element>
        } @else {
          <bic-dropdown-element (click)="$event.stopPropagation()">
            <div class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                 [tooltip]="noManageTooltip"
                 tooltipDirection="top">
              <fa-icon [icon]="faCopy" class="text-sm text-gray-400 w-4"></fa-icon>
              <span>Duplizieren</span>
            </div>
          </bic-dropdown-element>
        }
        @if (canCreateCheckRun) {
          <bic-dropdown-element (click)="onCreateCheckRun()">
            <div class="flex flex-row items-center gap-2 text-sm text-gray-900"
                 tooltip="Prüflauf mit diesem myCheck als vordefinierter Regelauswahl anlegen"
                 tooltipDirection="top">
              <fa-icon [icon]="faScrewdriverWrench" class="text-sm text-gray-700 w-4"></fa-icon>
              <span>Prüflauf erstellen</span>
            </div>
          </bic-dropdown-element>
        } @else {
          <bic-dropdown-element (click)="$event.stopPropagation()">
            <div [tooltip]="noCreateCheckRunTooltip"
                 class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                 tooltipDirection="top">
              <fa-icon [icon]="faScrewdriverWrench" class="text-sm text-gray-400 w-4"></fa-icon>
              <span>Prüflauf erstellen</span>
            </div>
          </bic-dropdown-element>
        }
        @if (canExport) {
          <bic-dropdown-element (click)="onExport()">
            <div class="flex flex-row items-center gap-2 text-sm text-gray-900"
                 tooltip="Verschlüsseltes Paket zur Wiederverwendung in anderen Projekten"
                 tooltipDirection="top">
              <fa-icon [icon]="faFileExport" class="text-sm text-gray-700 w-4"></fa-icon>
              <span>Exportieren</span>
            </div>
          </bic-dropdown-element>
        } @else {
          <bic-dropdown-element (click)="$event.stopPropagation()">
            <div [tooltip]="ruleset.isPrebuilt ? noExportPrebuiltTooltip : noManageTooltip"
                 class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                 tooltipDirection="top">
              <fa-icon [icon]="faFileExport" class="text-sm text-gray-400 w-4"></fa-icon>
              <span>Exportieren</span>
            </div>
          </bic-dropdown-element>
        }
        <!-- Teilen mit anderen Projekten der Organisation. Bewusst NICHT die Adminfunktion
             „Zentral bereitstellen" unten. -->
        @if (isLinkedIn) {
          @if (canUnshareHere) {
            <bic-dropdown-element (click)="onUnshareHere()">
              <div class="flex flex-row items-center gap-2 text-sm text-red">
                <fa-icon [icon]="faLinkSlash" class="text-sm w-4"></fa-icon>
                <span>Aus diesem Projekt entfernen</span>
              </div>
            </bic-dropdown-element>
          } @else {
            <bic-dropdown-element (click)="$event.stopPropagation()">
              <div [tooltip]="noManageTooltip"
                   class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                   tooltipDirection="top">
                <fa-icon [icon]="faLinkSlash" class="text-sm text-gray-400 w-4"></fa-icon>
                <span>Aus diesem Projekt entfernen</span>
              </div>
            </bic-dropdown-element>
          }
        } @else {
          @if (canShare) {
            <bic-dropdown-element (click)="onShare()">
              <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
                <fa-icon [icon]="faPaperPlaneTop" class="text-sm text-gray-700 w-4"></fa-icon>
                <span>Teilen</span>
              </div>
            </bic-dropdown-element>
          } @else {
            <bic-dropdown-element (click)="$event.stopPropagation()">
              <div [tooltip]="noManageTooltip"
                   class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                   tooltipDirection="top">
                <fa-icon [icon]="faPaperPlaneTop" class="text-sm text-gray-400 w-4"></fa-icon>
                <span>Teilen</span>
              </div>
            </bic-dropdown-element>
          }
        }
        @if (canTransferOwnership) {
          <bic-dropdown-element (click)="onTransferOwnership()">
            <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
              <fa-icon [icon]="faUserPen" class="text-sm text-gray-700 w-4"></fa-icon>
              <span>Eigentümer ändern</span>
            </div>
          </bic-dropdown-element>
        }
        <!-- Bei einem geteilten Set öffnet „Löschen" die Wahl zwischen Besitz übergeben und
             überall löschen – die Übersicht entscheidet anhand von sharedProjects. -->
        @if (isLinkedIn) {
          <!-- Löschen gibt es nur im Eigentümerprojekt; hier ersetzt „Aus diesem Projekt entfernen"
               den Eintrag. -->
        } @else if (canDelete) {
          <bic-dropdown-element (click)="onDelete()">
            <div class="flex flex-row items-center gap-2 text-sm text-red">
              <fa-icon [icon]="faTrash" class="text-sm w-4"></fa-icon>
              <span>Löschen</span>
            </div>
          </bic-dropdown-element>
        } @else {
          <bic-dropdown-element (click)="$event.stopPropagation()">
            <div [tooltip]="noDeleteTooltip"
                 class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                 tooltipDirection="top">
              <fa-icon [icon]="faTrash" class="text-sm text-gray-400 w-4"></fa-icon>
              <span>Löschen</span>
            </div>
          </bic-dropdown-element>
        }

        <!-- Nur für Plattform-Admins sichtbar und nur, wenn die Stage das Einreichen in den Katalog
             erlaubt; ein bereits bereitgestellter myCheck kann nicht erneut bereitgestellt werden. -->
        @if (canSubmitToCatalog) {
          <bic-dropdown-element (click)="onProvideGlobally()">
            <div class="flex flex-row items-center gap-2 text-sm text-red">
              <fa-icon [icon]="faShieldCheck" class="text-sm w-4"></fa-icon>
              <span>Zentral bereitstellen</span>
            </div>
          </bic-dropdown-element>
        }
      </bic-dropdown>
    }
  </div>

  <!-- Description; bei einem geteilten Set teilt sie sich die Höhe mit der Projektliste. -->
  @if (isSharedWithProjects) {
    <div class="flex flex-1 flex-col gap-1 min-h-0">
      <p class="text-sm text-gray-900 line-clamp-1">{{ ruleset.description }}</p>
      <div [tooltip]="'Geteilt mit: ' + sharedProjectsLabel"
           class="flex flex-row items-center gap-1.5 text-xs text-gray-500 min-w-0"
           tooltipDirection="top">
        <fa-icon [icon]="faShareNodes" class="shrink-0"></fa-icon>
        <span class="truncate">{{ sharedProjectsLabel }}</span>
      </div>
    </div>
  } @else {
    <p class="text-sm text-gray-900 flex-1 line-clamp-2">{{ ruleset.description }}</p>
  }

  <div class="flex flex-row items-center justify-between gap-3">
    <div class="flex flex-row gap-1">
      <span class="text-sm font-medium text-gray-900">{{ ruleset.ruleCount }}</span>
      <span class="text-sm text-gray-900">{{ ruleset.ruleCount === 1 ? 'Prüfregel' : 'Prüfregeln' }}</span>
    </div>
    @if (lastChangedAt) {
      <div [tooltip]="'Zuletzt geändert am ' + (lastChangedAt | date:'dd.MM.yyyy')"
           class="flex flex-row items-center gap-1.5 text-sm text-gray-900 shrink-0"
           tooltipDirection="top">
        <fa-icon [icon]="faClock" class="text-sm text-gray-500"></fa-icon>
        <span>{{ lastChangedAt | date:'dd.MM.yyyy' }}</span>
      </div>
    }
  </div>

  <!-- Aktionen: „Ausführen" ist die Hauptaktion – ein myCheck ist direkt ausführbar, ohne dass
       vorher ein Prüflauf gebaut werden muss (der nötige Prüflauf entsteht automatisch und unsichtbar).
       Daneben die zweite Aktion: „Duplizieren" auf zentral bereitgestellten Sets, sonst „Öffnen". -->
  <div class="flex flex-row gap-2">
    @if (!canExecute || !isExecutable) {
      <span [tooltip]="!canExecute ? noExecuteTooltip : notExecutableTooltip"
            class="flex-1"
            tooltipDirection="top">
        <bic-button [disabled]="true" buttonType="white" class="[&>button]:w-full">
          <fa-icon [icon]="faPlay" iconLeft></fa-icon>
          Ausführen
        </bic-button>
      </span>
    } @else {
      <bic-button (onClick)="onExecute()"
                  [disabled]="preparingRun"
                  buttonType="white"
                  class="flex-1 [&>button]:w-full">
        <fa-icon [icon]="faPlay" iconLeft></fa-icon>
        {{ preparingRun ? 'Wird gestartet …' : 'Ausführen' }}
      </bic-button>
    }

    @if (isProvided || isLinkedIn) {
      <!-- Vorgefertigt oder aus einem anderen Projekt geteilt: dieselbe Aktion wie auf der
           Prüflauf-Karte – duplizieren, nicht öffnen. -->
      @if (canDuplicate) {
        <bic-button (onClick)="onDuplicate()" buttonType="white" class="flex-1 [&>button]:w-full">
          <fa-icon [icon]="faCopy" iconLeft></fa-icon>
          Duplizieren
        </bic-button>
      } @else {
        <span [tooltip]="noManageTooltip" class="flex-1" tooltipDirection="top">
          <bic-button [disabled]="true" buttonType="white" class="[&>button]:w-full">
            <fa-icon [icon]="faCopy" iconLeft></fa-icon>
            Duplizieren
          </bic-button>
        </span>
      }
    } @else if (canManage) {
      <bic-button (onClick)="onOpen()" buttonType="white" class="flex-1 [&>button]:w-full">
        <fa-icon [icon]="faArrowUpRightFromSquare" iconLeft></fa-icon>
        Öffnen
      </bic-button>
    } @else {
      <span [tooltip]="noManageTooltip" class="flex-1" tooltipDirection="top">
        <bic-button [disabled]="true" buttonType="white" class="[&>button]:w-full">
          <fa-icon [icon]="faArrowUpRightFromSquare" iconLeft></fa-icon>
          Öffnen
        </bic-button>
      </span>
    }
  </div>
</div>
